export type ReportCategory =
  | 'carrier'
  | 'design-your-own'
  | 'detail'
  | 'financial'
  | 'summary'
  | 'usage'
  | 'other';

export interface ReportCategoryConfig {
  type: ReportCategory;
  displayName: string;
  matchKeywords: string[];
  sortOrder: number;
}

export const REPORT_CATEGORY_CONFIG: ReportCategoryConfig[] = [
  {
    type: 'carrier',
    displayName: 'Carrier',
    matchKeywords: ['carrier'],
    sortOrder: 1,
  },
  {
    type: 'design-your-own',
    displayName: 'Design Your Own',
    matchKeywords: ['design'],
    sortOrder: 2,
  },
  {
    type: 'detail',
    displayName: 'Detail',
    matchKeywords: ['detail'],
    sortOrder: 3,
  },
  {
    type: 'financial',
    displayName: 'Financial',
    matchKeywords: ['financial'],
    sortOrder: 4,
  },
  {
    type: 'summary',
    displayName: 'Summary',
    matchKeywords: ['summary'],
    sortOrder: 5,
  },
  {
    type: 'usage',
    displayName: 'Usage',
    matchKeywords: ['usage'],
    sortOrder: 6,
  },
  {
    type: 'other',
    displayName: 'Other',
    matchKeywords: [],
    sortOrder: 999,
  },
];

export class ReportCategoryUtil {
  static getCategoryFromGroup(group: string): ReportCategory {
    if (!group) return 'other';

    const normalizedGroup = group.toLowerCase();

    const matchedConfig = REPORT_CATEGORY_CONFIG.find((config) =>
      config.matchKeywords.some((keyword) => normalizedGroup.includes(keyword)),
    );

    return matchedConfig?.type ?? 'other';
  }

  static getDisplayName(category: ReportCategory): string {
    const config = REPORT_CATEGORY_CONFIG.find((c) => c.type === category);
    return config?.displayName ?? 'Other';
  }

  static getSortOrder(displayName: string): number {
    const config = REPORT_CATEGORY_CONFIG.find(
      (c) => c.displayName === displayName,
    );
    return config?.sortOrder ?? 999;
  }
}
